import Validator from "common/modules/validator";

export function departureCapacityRules(required = true) {
  const rule = () => {
    const number = Validator.rule.number().integer().min(1);
    return required ? number.required() : number;
  };
  return {
    number_of_places: rule(),
    number_of_online_places: rule(),
    places_tolerance: rule(),
  };
}
